// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/abs/views/home/component/right/hotRecommendList.less
// module id = 852
// module chunks = 42